module.exports = __webpack_public_path__ + "img/reactivation_failed.5231fdc1.svg";